module.exports = __webpack_public_path__ + "img/maccabi-tel-aviv-fc.8c8c2e67.png";